export enum ApprovalStatus {
  PENDING_REVIEW = 0,
  PENDING_PAYMENT = 1,
  AWAITING_REVISION = 2,
  UPDATED = 3,
  APPROVED = 4,
  DECLINED = 5
}
